import { Panel, tokens } from '@tiw/ui';
import { ROUTE_LIST } from '@/routes';
import { useViewportStore } from '@/stores/useViewportStore';
import type { SceneName } from '@/types';

interface RailEntry {
  readonly id: string;
  readonly label: string;
  readonly scene?: SceneName;
  readonly disabled?: boolean;
}

const AUX_ENTRIES: readonly RailEntry[] = [
  { id: 'layers', label: 'Layers', disabled: true },
  { id: 'time', label: 'Time', disabled: true },
  { id: 'settings', label: 'Settings', disabled: true },
];

/**
 * Left-edge command rail. Scene switches dispatch to the viewport store.
 * Non-scene entries are scaffolded for future phases and rendered disabled.
 */
export function CommandRail(): JSX.Element {
  const activeScene = useViewportStore((s) => s.scene);
  const setScene = useViewportStore((s) => s.setScene);

  const entries: readonly RailEntry[] = [
    ...ROUTE_LIST.map((r) => ({ id: r.name, label: r.label, scene: r.name })),
    ...AUX_ENTRIES,
  ];

  return (
    <Panel
      title="CMD"
      style={{
        position: 'absolute',
        top: 24,
        left: 24,
        width: 136,
        pointerEvents: 'auto',
      }}
    >
      <ul
        style={{
          listStyle: 'none',
          margin: 0,
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        {entries.map((entry) => {
          const isActive = entry.scene !== undefined && entry.scene === activeScene;
          return (
            <li key={entry.id}>
              <button
                type="button"
                disabled={entry.disabled}
                onClick={() => entry.scene && setScene(entry.scene)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  background: isActive ? tokens.color.surface.glass : 'transparent',
                  color: entry.disabled ? tokens.color.text.faint : tokens.color.text.primary,
                  border: `1px solid ${isActive ? tokens.color.border.info : tokens.color.border.neutral}`,
                  padding: '8px 10px',
                  fontFamily: 'JetBrains Mono, ui-monospace, monospace',
                  fontSize: 11,
                  letterSpacing: '0.18em',
                  textTransform: 'uppercase',
                  cursor: entry.disabled ? 'not-allowed' : 'pointer',
                  opacity: entry.disabled ? 0.5 : 1,
                  transition: 'background 160ms ease, border-color 160ms ease',
                }}
              >
                {entry.label}
              </button>
            </li>
          );
        })}
      </ul>
    </Panel>
  );
}
